module.exports = __webpack_public_path__ + "img/kls.289ebce6.png";